import { render, staticRenderFns } from "./PointSetting.vue?vue&type=template&id=a1a6a4d4&scoped=true&"
import script from "./PointSetting.vue?vue&type=script&lang=js&"
export * from "./PointSetting.vue?vue&type=script&lang=js&"
import style0 from "./PointSetting.vue?vue&type=style&index=0&id=a1a6a4d4&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../shared/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a1a6a4d4",
  null
  
)

export default component.exports